import axios from 'axios';
import { railsConfig } from '../API/railsConfig';

export const ENABLE_CLARITY_CFGKEY = 'rails_dweb_enable_clarity_script';
export const IRCTC_NEW_USER_REGISTRATION_URL = 'irctc_newuser_registration_url_desktop';
export const RAILS_TG_FC_TOGETHER_TEXT_CONFIG = 'rails_tg_fc_together_text_config_dweb';
export const LOGIN_PERSUASSUION_CONFIG = 'dweb_traveller_login_persuasion';
export const DWEB_AADHAR_MODAL_TEXT = 'dweb_aadhar_modal_text';
export const DWEB_FC_TG_CONFIGKEY = 'rails_dweb_fc_tg_config';

const CFGKEY_VALUES = 'cfgKeyValue';

export const getConfigKey = async (cfgKey : string, fallback: any) => {
    let response = fallback;
    const headers = {
    'Authorization': 'Tect685j8xMpLJF',
    };
    const body = {
        cfgKey: cfgKey,
    }
    const storageResponse = await JSON.parse(sessionStorage.getItem(CFGKEY_VALUES));

    if (storageResponse?.[cfgKey]) {
        return storageResponse?.[cfgKey];
    }

    await axios.post(railsConfig.configStoreUrl, body, { headers })
    .then((res) => {
        if(res?.data?.configKeys?.length > 0) {
            response = res.data.configKeys[0]?.value;
        }
        let newStorageResponse = {
            ...storageResponse,
            [cfgKey]: response
        }
        sessionStorage.setItem(CFGKEY_VALUES, JSON.stringify(newStorageResponse));
    })
    .catch((err) => {
        console.log('Error in fetching value from configStore: ', err);
    });
    return response;
};